{
  "id": "campaign-116",
  "name": "Noble Promenade II",
  "seed": "campaign:116",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".....UCCCCCCU.....",
    ".....UCCCCCCU.....",
    "......~.CCx.......",
    ".......~CC........",
    "..Y..t~.CC..t..Y..",
    "........CC,.......",
    ".......CCCC,......",
    "......BCwwCB......",
    "...t.t.CwwC.t.t,,.",
    "...q...CwwC...q...",
    ".t.t..,CCCC...t.t.",
    "*......,CC.......*",
    "*...~t~.CC..t....*",
    "*.B..~..CC.....B.*",
    "*.q....tCCt....q.*",
    "........CC.....x..",
    ".......x..x.......",
    "S................."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 7,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 15,
      "y": 17
    },
    {
      "kind": "rabbit",
      "x": 17,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 12
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 0,
      "y": 16
    },
    {
      "kind": "gas",
      "x": 4,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 4,
      "y": 8
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 16
    },
    {
      "kind": "rare",
      "x": 10,
      "y": 1
    }
  ],
  "hills": [
    {
      "x": 0,
      "y": 9,
      "w": 5,
      "h": 5
    },
    {
      "x": 13,
      "y": 9,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 116,
  "biome": "estate",
  "par": {
    "reel": 9435,
    "push": 8195,
    "selfPropelled": 7613,
    "tractor": 6349,
    "zeroTurn": 5399,
    "fairway": 3267
  },
  "goldTime": {
    "reel": 9419,
    "push": 8195,
    "selfPropelled": 7529,
    "tractor": 6194,
    "zeroTurn": 5364,
    "fairway": 2771
  },
  "routeTries": {
    "par": {
      "reel": 14,
      "push": 15,
      "selfPropelled": 0,
      "tractor": 14,
      "zeroTurn": 9,
      "fairway": 24
    },
    "gold": {
      "reel": 25,
      "push": 15,
      "selfPropelled": 25,
      "tractor": 42,
      "zeroTurn": 39,
      "fairway": 47
    }
  }
}
